import { generateColorPalette } from './color-generator';
import { PaletteColors, FontsColors } from './types';

export enum BASE_COLORS {
  grey = 'grey',
  tealGrey = 'tealGrey',
  silver = 'silver',
  red = 'red',
  pink = 'pink',
  orange = 'orange',
  mint = 'mint',
  turquoise = 'turquoise',
  blue = 'blue',
  green = 'green'
}

export const BASE_COLORS_LIST = Object.values(BASE_COLORS);

const greyBase = 'rgb(223, 227, 236)';
const tealGreyBase = 'rgb(115, 126, 148)';
const silverBase = 'rgb(243,243,243)';
const redBase = 'rgb(241, 113, 113)';
const pinkBase = 'rgb(236, 90, 135)';
const orangeBase = 'rgb(251, 160, 80)';
const mintBase = 'rgb(104, 198, 171)';
const turquoiseBase = 'rgb(59, 172, 197)';
const blueBase = 'rgb(78, 79, 185)';
const greenBase = 'rgb(60, 197, 114)';
const sageInputColor = 'rgba(0, 0, 0, 0.9)';
const sageInputBorder = '#668494';

export const Colors: PaletteColors = {
  white: 'rgb(255, 255, 255)',
  black: 'rgb(0, 0, 0)',
  transparent: 'rgba(0, 0, 0, 0)',
  [BASE_COLORS.grey]: generateColorPalette(greyBase),
  [BASE_COLORS.tealGrey]: generateColorPalette(tealGreyBase),
  [BASE_COLORS.silver]: generateColorPalette(silverBase),
  [BASE_COLORS.red]: generateColorPalette(redBase),
  [BASE_COLORS.pink]: generateColorPalette(pinkBase),
  [BASE_COLORS.orange]: generateColorPalette(orangeBase),
  [BASE_COLORS.mint]: generateColorPalette(mintBase),
  [BASE_COLORS.turquoise]: generateColorPalette(turquoiseBase),
  [BASE_COLORS.blue]: generateColorPalette(blueBase),
  [BASE_COLORS.green]: generateColorPalette(greenBase)
};

export const Fonts: FontsColors = {
  error: Colors.red.des1,
  success: Colors.green.base,
  greyLight: Colors.tealGrey.lighten5,
  greyDark: Colors.tealGrey.darken25,
  sageInputColor,
  sageInputBorder
};

export const CHART_COLORS = {
  POSITIVE: {
    PRIMARY: 'rgba(0,246,202,0.49)',
    SECONDARY: 'rgba(107,91,227,0.5)'
  },
  NEGATIVE: {
    PRIMARY: 'rgba(255,0,59,0.45)',
    SECONDARY: 'rgba(255,131,48,0.44)'
  }
};
